import { useState } from "react";
import { api } from "../../lib/api";

const initial = { full_name: "", email: "", phone: "", category: "Portal Issue", subject: "", message: "" };

export default function HelpDesk() {
  const [form, setForm] = useState(initial);
  const [ticket, setTicket] = useState("");
  const [track, setTrack] = useState("");
  const [trackResult, setTrackResult] = useState(null);
  const [error, setError] = useState("");

  async function submit(e) {
    e.preventDefault();
    setError("");
    setTicket("");
    try {
      const data = await api("/api/support-tickets", { method: "POST", body: JSON.stringify(form) });
      setTicket(data.ticket_number);
      setForm(initial);
    } catch (err) {
      setError(err.message);
    }
  }

  async function trackTicket(e) {
    e.preventDefault();
    setError("");
    setTrackResult(null);
    try {
      const data = await api(`/api/support-tickets/track/${track}`);
      setTrackResult(data);
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <main className="bg-slate-50 px-4 py-16">
      <section className="mx-auto max-w-6xl">
        <p className="text-sm font-bold uppercase tracking-[0.25em] text-emerald-700">Student Support</p>
        <h1 className="mt-3 text-4xl font-black text-slate-900">Help Desk & Complaint Tracking</h1>
        <p className="mt-3 max-w-2xl text-slate-600">Submit portal, admission, payment, clearance, timetable, or result-related issues and track progress.</p>

        {error && <div className="mt-6 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}
        {ticket && <div className="mt-6 rounded-xl bg-emerald-50 p-4 font-semibold text-emerald-700">Ticket submitted. Tracking number: {ticket}</div>}

        <div className="mt-8 grid gap-6 lg:grid-cols-3">
          <form onSubmit={submit} className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200 lg:col-span-2">
            <h2 className="text-xl font-bold text-slate-900">Submit a Complaint</h2>
            <div className="mt-4 grid gap-4 md:grid-cols-2">
              <input className="rounded-xl border p-3" placeholder="Full name" value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} required />
              <input className="rounded-xl border p-3" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <input className="rounded-xl border p-3" placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              <select className="rounded-xl border p-3" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
                <option>Portal Issue</option><option>Payment Issue</option><option>Admission Issue</option><option>Result Issue</option><option>Clearance Issue</option><option>General Complaint</option>
              </select>
              <input className="rounded-xl border p-3 md:col-span-2" placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} required />
              <textarea className="min-h-36 rounded-xl border p-3 md:col-span-2" placeholder="Describe the issue" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required />
              <button className="rounded-xl bg-emerald-700 px-5 py-3 font-bold text-white md:col-span-2">Submit Ticket</button>
            </div>
          </form>

          <form onSubmit={trackTicket} className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
            <h2 className="text-xl font-bold text-slate-900">Track Ticket</h2>
            <input className="mt-4 w-full rounded-xl border p-3" placeholder="FPB-TICKET-2026-XXXX" value={track} onChange={(e) => setTrack(e.target.value)} required />
            <button className="mt-3 w-full rounded-xl bg-slate-950 px-5 py-3 font-bold text-white">Track</button>
            {trackResult && <div className="mt-4 rounded-2xl bg-slate-50 p-4 text-sm"><p className="font-bold">{trackResult.subject}</p><p>Status: {trackResult.status}</p><p>Priority: {trackResult.priority}</p></div>}
          </form>
        </div>
      </section>
    </main>
  );
}
